import constants from "../constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const {
  GET_PRODUCTS, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_ERROR,
  ADD_PRODUCT, ADD_PRODUCT_SUCCESS, ADD_PRODUCT_ERROR,
  EDIT_PRODUCT, EDIT_PRODUCT_SUCCESS, EDIT_PRODUCT_ERROR,
  DELETE_PRODUCT, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_ERROR
} = constants;

const initialState = { loading: false, products: [], message: '', error: '' }

export const productReducer = (state = initialState, action) => {
  const { type, products, message, error } = action;
  switch (type) {
    case GET_PRODUCTS:
    case ADD_PRODUCT:
    case EDIT_PRODUCT:
    case DELETE_PRODUCT:
      return { ...state, loading: true, error: '', message: '' }

    case GET_PRODUCTS_SUCCESS:
      return { ...state, loading: false, products }
    case ADD_PRODUCT_SUCCESS:
    case EDIT_PRODUCT_SUCCESS:
    case DELETE_PRODUCT_SUCCESS:
      return { ...state, loading: false, message: successHandle(message) }

    case GET_PRODUCTS_ERROR:
    case ADD_PRODUCT_ERROR:
    case EDIT_PRODUCT_ERROR:
    case DELETE_PRODUCT_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
